import EventService from "../../services/EventService";
import { indexById } from "../../components/Utils";

export const namespaced = true;


export const state = {
    loading: 0,
    cached: false,
    slots: [],
    byId: {}
};

export const mutations = {
    SET_LOADING(state, percent) {
        state.loading = percent;
    },
    SET_CACHED(state, value) {
        state.cached = value;
    },
    SET_SLOTS(state, slots) {
        state.slots = slots;
    },
    SET_BYID(state, indexed) {
        state.byId = indexed;
    }
};

export const actions = {
    async fetchSlots(context, cached) {
        return EventService.getSlots(cached)
            .then(response => {
                context.commit('SET_LOADING', 50);
                context.commit('SET_SLOTS', response.data);
                context.commit('SET_CACHED', Boolean(response.isCached))
                context.commit('SET_BYID', indexById(response.data));
            })
            .catch(error => {
               console.log('getSlots failed: ', error.message)
            })
            .finally(() => {
                context.commit('SET_LOADING', 100);
            });
    }
};

export const getters = {
    isCached: (state) => {
        return state.isCached;
    },
    slotsByDay: (state) => {
        const days = [];
        for (let i = 0, max = state.slots.length; i < max; i++) {
            let slot = state.slots[i];
            //console.log(slot);
            if (! (slot.day in days)) {
                days[slot.day] = [];
            }
            days[slot.day].push(slot);
        }
        return days;
    },
    all: (state) => {
        return state.slots;
    },
};

